<template>
	<div class="card_container" @click="navTo(navIndex)">
		<div class="card_hd item_flex">
			<div class="card_tit">
				<div class="tag" v-if="dep" :style="[depBgColor(dep)]">{{dep}}报告</div>
				<img class="icon" v-else-if="navType" :src="require('../static/img/icons/s_t_'+navType+'.png')"></img>
				<span class="txt" v-if="!dep">{{title}}</span>
			</div>
			<div class="card_tit_price" v-if="price">￥{{price}}</div>
			<div class="card_tit_txt" v-else-if="titTxt">{{titTxt}}</div>
			<div class="card_tit_type" v-else-if="titType">{{titType}}</div>
			<div class="card_tit_arrtxt" v-else>
				<div v-if="dep" class="tit_type">{{title}}</div>
				<img class="card_tit_arr" src="../static/img/icons/arrow-right.png"></img>
			</div>
		</div>
		<div class="card_info">
			<div class="card_info_item item_flex">
				<div class="ci_label">
					<img class="icon" src="../static/img/icons/company-fill.png"></img>
					<div class="txt">检查医院</div>
				</div>
				<div class="ci_text">{{hospitalName}}</div>
			</div>
			<div class="card_info_item item_flex">
				<div class="ci_label">
					<img class="icon" src="../static/img/icons/calendar-fill.png"></img>
					<div class="txt">检查日期</div>
				</div>
				<div class="ci_text">{{checkTime}}</div>
			</div>
		</div>
	</div>
</template>

<script>
import util from '../utils/util.js'
export default {
  name: 'navcard',
  props: {
    navIndex: {
      type: Number,
      default: 1
    },
    navId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    hospitalName: {
      type: String,
      default: ''
    },
    checkTime: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    searchType: {
      type: String,
      default: ''
    },
    navType: {
      type: String,
      default: ''
    },
    dep: {
      type: String,
      default: ''
    },
    titTxt: {
      type: String,
      default: ''
    },
    titType: {
      type: String,
      default: ''
    }
  },

  methods: {
    navTo (index) {
      this.$emit('toDetail', index)
    },
    depBgColor (type) {
      const _color = util.flrColorDep(type)
      return {'color': _color}
    },
    utilDateFormatter (str) {
      return util.dateFormatter(str, false, true)
    }
  }

}
</script>

<style lang="scss" scoped>
.item_flex{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.card_container{
	padding: 0 10px;
	background: #fff;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
	border-radius: 8px;
	margin-bottom: 16px;
}
.card_hd{
	padding: 10px 0;
	border-bottom: solid 0.5px #ECEEF5;
	.card_tit{
		display: flex;
		align-items: center;
		.icon{
			display: block;
			width: 20px;
			height: 20px;
		}
		.tag{
			font-size: 14px;
			// color: #fff;
			font-weight: bold;
			height: 20px;
			line-height: 20px;
		}
		.txt{
			font-size: 14px;
			// font-weight: bold;
			color: #303133;
			margin-left: 4px;
		}
	}
	.card_tit_arrtxt{
		display: flex;
		.tit_type{
			font-size: 18px;
			color: #606266;
		}
	}
	.card_tit_arr{
		display: block;
		width: 20px;
		height: 20px;
	}
	.card_tit_price{
		font-size: 14px;
		color: #F94242;
	}
	.card_tit_txt{
		font-size: 14px;
		color: #303133;
		font-weight: bold;
	}
	.card_tit_type{
		font-size: 14px;
		color: #606266;
		font-weight: bold;
	}
}
.card_info{
	padding: 7px 0;
}
.card_info_item{
	padding: 7px 0;
	.ci_label{
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #919398;
		.icon{
			display: block;
			width: 16px;
			height: 16px;
			margin:0 2px;
			margin-right: 6px;
		}
	}
	.ci_text{
		width: 70%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		font-size: 13px;
		color: #5F6266;
		text-align: right;
	}
}
</style>



// WEBPACK FOOTER //
// packages/appletView/src/components/navCard.vue